import { useState, useEffect } from 'react';
import { Box, Stack, Typography } from '@mui/material';

import fetchFromApi from '../utils/fetchFromApi';
import { Sidebar, Videos } from '../components';

export default function Feed() {
  const [selectedCategory, setSelectedCategory] = useState('New');
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetchFromApi(`search?part=snippet&q=${selectedCategory}`).then((data) =>
      setVideos(data.items)
    );
  }, [selectedCategory]);

  return (
    <Stack sx={{ flexDirection: { sx: 'column', md: 'row' } }}>
      <Box
        sx={{
          height: { sx: 'auto', md: '92vh' },
          px: { sx: 0, md: 2 },
          borderRight: '1px solid #3d3d3d',
        }}
      >
        <Sidebar
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
        <Typography
          sx={{ mt: 1.5, color: '#fff' }}
          variant="body2"
          className="copyright"
        >
          Copyright 2022 Youtube
        </Typography>
      </Box>
      <Box
        p={2}
        sx={{
          overflow: 'auto',
          height: '90vh',
          flex: 2,
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          mb={2}
          sx={{
            color: '#fff',
          }}
        >
          {selectedCategory} <span style={{ color: '#fc1503' }}>videos</span>
        </Typography>
        <Videos videos={videos} />
      </Box>
    </Stack>
  );
}
